module.exports = __webpack_public_path__ + "img/auth0-stencil.4030e97a.svg";